module.exports = __webpack_public_path__ + "static/media/solutionpage-5@2x.70d8451f.png";